<template>
  <div class="logo">
    <router-link to="/dashboard">
        <img class="metastory-logo light" src="../../../../assets/logo/logo-mark.svg" title="metastory" alt="">
        <img class="metastory-logo dark" src="../../../../assets/logo/logo-mark-white.svg" title="metastory" alt="">
    </router-link>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LogoElement',
  methods: {
    goToDashboard(e: Event): void {
      this.$router.push('/dashboard');
      e.preventDefault();
    },
  },
});

</script>
<style lang="scss" scoped>

  .logo{
    padding: var(--space-16);
    margin-top: var(--space-12);;
    margin-bottom: var(--space-16);;

    & img {
      width: 28px;
      height: auto;
    }
  }

</style>
